<!-- Sidebar -->
	<div class="w-(--sidebar-width) z-5 lg:top-[80px] top-0 bottom-0 lg:right-auto lg:start-auto shrink-0 py-3 lg:py-0 bg-background" data-kt-sticky="true" data-kt-sticky-class="fixed" data-kt-sticky-name="sidebar" data-kt-sticky-offset="150px" data-kt-sticky-initialized="true">
		<div class="kt-scrollable-y-auto" data-kt-scrollable="true" data-kt-scrollable-dependencies="#header" data-kt-scrollable-height="auto" data-kt-scrollable-offset="10px" id="sidebar_scrollable" data-kt-scrollable-initialized="true" style="height: 1191px;">
			<!-- Navs -->
			<div class="flex flex-col gap-7.5 px-2.5">
				<!-- Dropdown -->
				<div class="kt-menu kt-menu-default w-full p-0 gap-0.5" data-kt-menu="true">
					<div class="kt-menu-item w-full kt-menu-item-dropdown" data-kt-menu-item-offset="0, 0" data-kt-menu-item-placement="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click">
						<button class="kt-menu-toggle w-full kt-btn kt-btn-outline justify-between flex-nowrap">
							<span class="flex items-center gap-1.5">
								<i class="ki-filled ki-code text-base!">
								</i>
								Client API
							</span>
							<span class="flex items-center lg:ms-4">
								<i class="ki-filled ki-down text-xs!">
								</i>
							</span>
						</button>
						<div class="kt-menu-dropdown w-[182px] py-2">
							<div class="kt-menu-item active">
								<a class="kt-menu-link" href="#">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-calendar">
										</i>
									</span>
									<span class="kt-menu-title">
										Client API
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link" href="#">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-calendar">
										</i>
									</span>
									<span class="kt-menu-title">
										Client API
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
				<!-- End of Dropdown -->
				<!-- Menu -->
				<div class="kt-menu flex-col gap-5" data-kt-menu="true">
					<div class="flex flex-col gap-px">
						<div class="kt-menu-item">
							<div class="px-2 text-xs font-medium text-secondary-foreground">
								Configuration
							</div>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-setting text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									API Setup
								</span>
							</a>
						</div>
						<div class="kt-menu-item active">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-users text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Team Settings
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-password-check text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Authentication
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-technology-4 text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Endpoints Configs
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-chart-line-star text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Rate Limiting
								</span>
							</a>
						</div>
					</div>
					<div class="flex flex-col gap-px">
						<div class="kt-menu-item">
							<div class="px-2 text-xs font-medium text-secondary-foreground">
								Security
							</div>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-chart-line-star text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Data Encryption
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-percentage text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Rate Limiting
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-safe-home text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Access Control
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-status text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Incident Response
								</span>
							</a>
						</div>
					</div>
					<div class="flex flex-col gap-px">
						<div class="kt-menu-item">
							<div class="px-2 text-xs font-medium text-secondary-foreground">
								Analytics
							</div>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-calendar-8 text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Fetching Data
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-office-bag text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Custom Reports
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link py-2 px-2.5 gap-2 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-safe-home text-muted-foreground text-lg">
									</i>
								</span>
								<span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
									Real Time Analytics
								</span>
							</a>
						</div>
					</div>
				</div>
				<!-- End of Menu -->
			</div>
			<!-- End of Navs -->
		</div>
	</div>
<!-- End of Sidebar -->